import React, { ReactElement } from 'react';
import { Box } from '@mui/material';
import Image from 'next/image';
import { Header } from 'components/ui';
import { LogInForm } from 'components/forms';
const LOGIN_IMAGE = '/img/campusLush-login.jpg';

export default function LoginPage(): ReactElement {
  return (
    <Box
      width="100vw"
      height="100vh"
      minHeight="100vh"
      display="flex"
      flexDirection="column"
    >
      <Header loggedIn={false} showSearch={false} />
      <Box flex={1} display="flex" flexDirection={{ xs: 'column', md: 'row' }}>
        <Box
          width={{ xs: '100%', md: '50%' }}
          height={{ xs: 'auto', md: '100vh' }}
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          bgcolor={theme => theme.palette.background.default}
        >
          <Box
            width="100%"
            maxWidth={620}
            px={{ xs: 2, md: 8 }}
            p={{ xs: '100px 20px', md: '50px 60px', xl: '100px 120px' }}
            pb={{ xs: 100, md: 200, xl: 400 }}
          >
            <LogInForm />
          </Box>
        </Box>
        <Box
          width="50%"
          height="100vh"
          position="relative"
          flexShrink={0}
          display={{ xs: 'none', md: 'block' }}
        >
          <Image
            src={LOGIN_IMAGE}
            alt="Campus"
            layout="fill"
            objectFit="cover"
            priority
          />
        </Box>
      </Box>
    </Box>
  );
}
